import { withProps } from 'recompose'
import { defineMessages } from 'react-intl'
import Eurotrip from './Eurotrip'

export default {
  GemContainer: withProps({
    qaTag: 'euroTripGem',
    amount: 15000
  }),
  Detail: Eurotrip,
  ...defineMessages({
    question: {
      id: 'Homeowner.equity.eurotripQuestion',
      defaultMessage: "What's the best use of my equity?"
    },
    topic: {
      id: 'Homeowner.equity.eurotripTopic',
      defaultMessage: 'their cashout options'
    }
  })
}
